import React from 'react'
import TextCard from '~/components/Dynamic/TextCard';
import StepsAnimation from '~/components/StepsAnimation'

export default function Steps({blok}) {
  return (
    <section className="my-20 md:my-28">
      <div className="container max-w-4xl mx-auto">
        <div
          className={`flex flex-wrap md:flex-nowrap -ml-12 space-y-12 md:space-y-0`}>
          <div className={`w-full hidden md:block flex-auto pl-12 md:w-1/2 `}>
            <StepsAnimation />
          </div>
          <div className={`flex-auto flex flex-col pl-12 md:w-1/2 items-center text-center md:text-left justify-start`}>
            {blok.steps?.length > 0 &&
              blok.steps.map((step, i) => (
                <TextCard key={i} blok={step}  />  
              ))
            }
          </div>
        </div>
      </div>
    </section>
  )
}
